import {Component} from 'react'
import MoodTrackerContext from '../../context/MoodTrackerContext'
import Header from '../Header'
import Calendar from '../Calendar'
import './index.css'

class Home extends Component {
  render() {
    return (
      <MoodTrackerContext.Consumer>
        {value => {
          const {
            emojisListNew,
            nameDayCount,
            activeEmoji,
            calenderList,
            daysList,
            activeEmojiName,
            activeDay,
            onEmojiClick,
            onEmojiNameChange,
            onDayChange,
          } = value

          return (
            <>
              <Header />
              <div className="home-body-container">
                <h1 className="home-main-heading">Moods in a Month</h1>
                <div className="home-all-container">
                  <div className="calender-container1">
                    <Calendar calenderList={calenderList} />
                  </div>
                  <div className="helloMoto">
                    <div className="emojis-list-container">
                      <ul className="emoji-ul">
                        {emojisListNew.map(item => {
                          const {id, emojiName, emojiUrl} = item
                          const onEmojiSelect = () => {
                            onEmojiClick(id)
                          }
                          const activeEmojiClass =
                            activeEmoji === id ? 'activeEmoji' : ''
                          const activeEmojiPara =
                            activeEmoji === id ? 'activeEmojiPara' : ''
                          const activeEmojiButton =
                            activeEmoji === id ? 'activeEmojiButton' : ''
                          return (
                            <li key={id} className="emoji-li">
                              <button
                                data-testid="emojiButton"
                                type="button"
                                onClick={onEmojiSelect}
                                className={`emoji-button ${activeEmojiButton}`}
                              >
                                <p className={`emoji-para ${activeEmojiPara}`}>
                                  {emojiName}
                                </p>
                                <img
                                  className={`emoji-img ${activeEmojiClass}`}
                                  src={emojiUrl}
                                  alt={emojiName}
                                />
                              </button>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                    <div className="select-container">
                      <select
                        onChange={onEmojiNameChange}
                        value={activeEmojiName}
                        className="emoji-select"
                      >
                        {emojisListNew.map(item => (
                          <option key={item.id} value={item.emojiName}>
                            {item.emojiName}
                          </option>
                        ))}
                      </select>
                      <select
                        onChange={onDayChange}
                        value={activeDay}
                        className="day-select"
                      >
                        {daysList.map(item => (
                          <option key={item.id} value={item.dayNumber}>
                            {item.day}
                          </option>
                        ))}
                      </select>
                      <h1 className="name-day-count">{nameDayCount}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )
        }}
      </MoodTrackerContext.Consumer>
    )
  }
}

export default Home
